const NetworkType = {
    1: 'Cable',
    2: 'Stations',
    3: 'Radio',
};

export default NetworkType